/* RMH · Curious Explorer LP — shared behaviour (loaded once via header section).
 * 1) Scroll reveal for .ce-reveal (honours prefers-reduced-motion)
 * 2) Sticky CTA bar: shows after the hero, hides over the offer block / footer */
(function () {
  function revealAll(els) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  function initReveal() {
    var els = document.querySelectorAll('.ce-reveal');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(els);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  function initSticky() {
    var bar = document.querySelector('[data-ce-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;

    var hero = document.querySelector('.rmh-ce-hero');
    var hideZones = document.querySelectorAll('[data-ce-offer], .rmh-ce-footer');
    var pastHero = !hero;
    var hidingCount = 0;

    function update() {
      var show = pastHero && hidingCount === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (hero) {
      new IntersectionObserver(function (entries) {
        pastHero = !entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(hero);
    }

    if (hideZones.length) {
      var zoneObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          hidingCount += entry.isIntersecting ? 1 : -1;
        });
        if (hidingCount < 0) hidingCount = 0;
        update();
      }, { threshold: 0 });
      for (var i = 0; i < hideZones.length; i++) zoneObs.observe(hideZones[i]);
    }

    update();
  }

  function init() {
    initReveal();
    initSticky();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
